import React from "react";
import "./input.css";
import { InputProps } from "../../GameTypes/game.type";
const Input: React.FC<InputProps> = ({
  type = "text",
  placeholder,
  value,
  onChange,
  ...rest
}) => {
  return (
    <input
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      className="betInput"
      {...rest}
    />
  );
};

export default Input;